export default class ExternalService {
    static get $inject() {
        return [
            '$http', 'ApiService'
        ];
    }

    constructor($http, ApiService) {
        this.$http = $http;
        this._api = ApiService.api;
    }

    getExternals(panel_id) {
        return this.$http.get(`${this._api}/external/${panel_id}/`)
            .then(resp => resp.data.data)
            .catch(() => [])
    }
}



/** WEBPACK FOOTER **
 ** ./src/services/api/api.external.service.js
 **/